import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 2H10v2h5v18h3V4h5V2zM7 10h3v2H7v10H4V12H1v-2h6z" }));
export default createSvgIcon(iconPath, "Headline");
//# sourceMappingURL=HeadlineIcon.js.map